"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = void 0;
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
exports.CheckBox = (props) => {
    const { id, name, label, inputClass, labelClass } = props;
    return (react_1.default.createElement("div", { className: "form-check checkbox" },
        react_1.default.createElement(formik_1.Field, { name: name, component: ({ field }) => (react_1.default.createElement("input", Object.assign({ type: "checkbox", id: id || `${name}-input`, checked: field.value, className: inputClass || 'form-check-input' }, field))) }),
        react_1.default.createElement("label", { htmlFor: id || `${name}-input`, className: labelClass || 'form-check-label' }, label)));
};
//# sourceMappingURL=CheckBox.js.map